import {
  TENANT_LOADING,
  TENANT_DATA,
} from './TenantActions';

const INITIAL_STATE = {
  error: '',
  loaded: false,
  loading: true,
  tenant: null,
};

const TenantReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TENANT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case TENANT_DATA:
      return {
        ...state,
        error: '',
        loaded: action.payload.loaded,
        loading: false,
        tenant: action.payload.data,
      };
  }

  return state;
};

export default TenantReducer;
